module.exports = __webpack_public_path__ + "static/media/calendar.af0b4a05.svg";